<mat-toolbar [ngClass.xs]="cssMobile" [ngClass]="cssNormal" fxLayoutGap="40px"   fxLayout="row"    fxLayoutAlign="start center">
  <div style="padding-left: 20px; font-family: SLBSans-Regular;" fxFlex ngStyle.xs="padding-left: 0px;" *ngIf="
      !showBack &&
      !showTemplateSingleWord &&
      !showTemplateDoubleWord &&
      !showTemplateTripleWord &&
      !showTemplateWithBackButton &&
      !showSingleWordTemplateWithBackButton &&
      !showTemplateWithBackAndThreeLetterButton
    " fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start center">
    <img alt="img" *ngIf="loginStatus" ngClass="img-drawer" [src]="drawerToggleIcon" (click)="onToggleSidenav()" />
    <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start end">
      <img id="img1" ngClass="onesiteimg" [src]="slbSafeImage" alt="onesiteimg" />
      <img id="img2" [src]="slbSafeImageMobile1" alt="">
    </div>
  <span fxFlex></span>
    <div fxFlex="none">
      <app-navigation-buttons></app-navigation-buttons>
    </div>
  </div>

  <div fxLayout="row" *ngIf="
      showBack ||
      showTemplateSingleWord ||
      showTemplateDoubleWord ||
      showTemplateTripleWord ||
      showTemplateWithBackButton ||
      showSingleWordTemplateWithBackButton ||
      showTemplateWithBackAndThreeLetterButton
    " fxLayoutGap="39vw" [fxLayoutGap.xs]="layoutGapxs" fxLayoutGap.sm="26vw" fxLayoutGap.md="29vw"
    fxLayoutGap.lg="34vw" fxLayoutGap.xl="39vw" fxLayoutAlign.xs="center center" fxLayoutAlign="start center">
    <img style="padding-left: 20px;" ngStyle.xs="padding-left: 0px;" *ngIf="
        showTemplateSingleWord ||
        showTemplateDoubleWord ||
        showTemplateTripleWord
      " fxFlexAlign.xs="center" ngClass="img-drawer" [src]="drawerToggleIcon" (click)="onToggleSidenav()" alt="menu" />

    <span style="padding-left: 20px;" ngStyle.xs="padding-left: 0px;" *ngIf="showBack" fxLayout="row" (click)="onBack()"
      fxLayoutGap="5px" class="button-back">
      <img class="img-icon" src="assets/icons/back@3x.png" alt="back" />
      <span fxHide.xs="true">{{'back' | transloco}}</span>
    </span>
    <span *ngIf="selectedTab === 'Proxy' && showBack && proxy" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="5px"
      style="color: white;">
      <span style="font-size: 28px;padding-left: 7vw;white-space: initial; font-family: SLBSans-Bold;"
        ngStyle.xs="font-size:18px;padding-left: calc(100vw - 85vw);">{{'proxy' | transloco}}</span>
    </span>
    <span *ngIf="showTemplateSingleWord" fxFlexAlign.xs="center" fxLayout="row" fxLayoutAlign="end end"
      fxLayoutGap="5px" style="color: white;">
      <span dir="auto" style="font-size: 28px;padding-left: 8vw;white-space: initial; font-family: SLBSans-Bold;"
        ngStyle.xs="font-size:18px">{{toolbarTitle | async}}</span>
    </span>
    <span *ngIf="showTemplateDoubleWord" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="5px" style="color: white;">
      <span dir="auto" style="font-size: 28px;padding-left: 5vw;white-space: initial; font-family: SLBSans-Bold;"
        ngStyle.xs="font-size:18px">{{toolbarTitle | async}}</span>
    </span>
    <span *ngIf="showTemplateTripleWord" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="5px" style="color: white;">
      <span dir="auto" style="font-size: 28px;padding-left: 1vw;white-space: initial; font-family: SLBSans-Bold;"
        ngStyle.xs="font-size:18px">{{toolbarTitle | async}}</span>
    </span>
    <span *ngIf="showTemplateWithBackButton" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="5px"
      style="color: white;">
      <span dir="auto" style="font-size: 28px;padding-left: 2vw;white-space: initial; font-family: SLBSans-Bold;"
        ngStyle.xs="font-size:18px;padding-left: 7vw;">{{toolbarTitle | async}}</span>
    </span>
    <span *ngIf="showSingleWordTemplateWithBackButton" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="5px"
      style="color: white;">
      <span dir="auto" style="font-size: 28px;padding-left: 5vw;white-space: initial; font-family: SLBSans-Bold;"
        ngStyle.xs="font-size:18px;padding-left: 9vw;">{{toolbarTitle | async}}</span>
    </span>
    <span *ngIf="showTemplateWithBackAndThreeLetterButton" fxLayoutGap="5px" style="color: white">
      <span dir="auto" style="font-size: 28px;white-space: initial; font-family: SLBSans-Bold;" ngStyle.xs="font-size:18px;">{{toolbarTitle | async}}</span>
    </span>
  </div>
</mat-toolbar>
